import { IPageResult } from '../../interfaces/page-result';
import { IUserRequest } from '../../interfaces/user-request';
import { IUserRequestFilter } from '../../interfaces/user-request-filter';
import { OrganisationsService } from '../../services';
import { UserRequestService } from '../../services';
import { BBWTMessageService } from '../../services';
import { LazyLoadEvent, ConfirmationService, Message, SelectItem, Table } from 'primeng';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export enum UserRequestStatus {
  Created = 0,
  Confirmed = 1,
  Refused = 2,
  Responded = 3,
}

@Component({
  selector: 'user-requests',
  templateUrl: 'user-requests.component.html',
  styleUrls: ['./new-user-request.component.css'],
})
export class UserRequestsComponent implements OnInit {
  public isBusy: boolean = false;
  public page: IPageResult<IUserRequest> = {
    items: [],
    total: 0,
  };
  public statuses: SelectItem[];
  public organisationSubTypes: SelectItem[];
  public filter: Subject<IUserRequestFilter>;
  public filterVal: IUserRequestFilter;
  public refuseDetails: any;

  private _selectedUserRequest: IUserRequest;
  get selectedUserRequest(): IUserRequest {
    return this._selectedUserRequest;
  }

  set selectedUserRequest(value: IUserRequest) {
    this._selectedUserRequest = value;
    if (value) {
      this.showConfirmButton = value.statusText == UserRequestStatus[UserRequestStatus.Created];
      this.showResendButton = value.statusText == UserRequestStatus[UserRequestStatus.Confirmed];
    } else {
      this.showConfirmButton = this.showResendButton = false;
    }
  }

  public isShowDetails: boolean = false;
  public isShowRefuse: boolean = false;

  public showConfirmButton: boolean = false;
  public showResendButton: boolean = false;

  public refuseUserRequestForm: UntypedFormGroup;

  constructor(
    private userRequestService: UserRequestService,
    private organisationsService: OrganisationsService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public messageService: BBWTMessageService,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();

    this.getOrganisationSubTypes();
    this.initRequestStatuses();

    this.refuseUserRequestForm = new UntypedFormGroup({
      sendEmail: new UntypedFormControl(false),
      reasonForFailure: new UntypedFormControl(''),
    });

    this.filter = new Subject<IUserRequestFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => this.load(f));
    this.filter.next(this.filterVal);
  }

  initRequestStatuses() {
    this.statuses = [
      {
        label: 'Status (All)',
        value: null,
      },
    ].concat(
      Object.keys(UserRequestStatus)
        .filter((key) => isNaN(parseInt(key)))
        .map((key) => ({
          value: UserRequestStatus[key],
          label: key,
        })),
    );
  }

  getOrganisationSubTypes() {
    this.organisationsService.getSubTypes().then((result) => {
      this.organisationSubTypes = [{ label: 'Organisation Type (All)', value: null }];
      if (result != null) {
        result.forEach((item) => {
          this.organisationSubTypes.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  load(filter: IUserRequestFilter) {
    this.isBusy = true;
    this.userRequestService
      .getPage(filter)
      .then((result) => {
        this.isBusy = false;
        this.page = result;
      })
      .catch((ex) => {
        this.isBusy = false;
      });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    if (event.sortField) {
      this.filterVal.sortField = event.sortField;
      this.filterVal.sortOrder = event.sortOrder;
    }

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'status', // ASC
      sortOrder: 1,
      filters: {
        email: {},
        organisation: {},
        organisationSubTypeId: {},
        phoneNumber: {},
        status: {},
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  confirm(userRequest, isResent) {
    this.isShowDetails = false;
    this.isBusy = true;
    this.userRequestService
      .confirm(userRequest, isResent)
      .then((result) => {
        this.selectedUserRequest = null;
        this.isBusy = false;
        this.messageService.ShowSuccess('Success', 'The new user is now accepted.');
        this.filter.next(this.filterVal);
      })
      .catch((ex) => {
        this.isBusy = false;
        this.messageService.ShowError('Error', 'Failed to create the new user.');
      });
  }

  showDetais(userRequest) {
    this.isShowDetails = true;
  }

  closeDetailsDialog() {
    this.isShowDetails = false;
  }

  refuse(userRequest) {
    this.isShowDetails = false;

    this.refuseDetails = {
      userRequest: userRequest,
      isSendEmail: true,
      reasonForFailure: '',
    };
    this.isShowRefuse = true;
  }

  refuseForm(refuseDetails) {
    this.isShowDetails = false;
    this.isBusy = true;

    this.userRequestService
      .refuse(refuseDetails)
      .then((result) => {
        this.selectedUserRequest = null;
        this.isBusy = false;
        this.isShowRefuse = false;
        this.messageService.ShowSuccess('Refuse', 'The new user has been refused.');
        this.filter.next(this.filterVal);
      })
      .catch((ex) => {
        this.isBusy = false;
        this.messageService.ShowError('Error', 'Failed to refuse the new user.');
      });
  }

  closeRefuseDialog() {
    this.isShowRefuse = false;
  }
}
